import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  components: {
    Modal: {
      defaultProps: {
        size: { base: "full", md: "lg" },
      },
    },
  },
});

export default theme;
